import { classNamesFor } from '../../../utils/classNames';

const factory = classNamesFor('ControlLabel');

export const controlLabelClassNames = {
  root: factory.root(),
  control: factory.element('control'),
  errorMessage: factory.element('error-message'),
  bottomContent: factory.element('bottom-content'),
  disabled: factory.attribute('disabled'),
  required: factory.attribute('required'),
  error: factory.attribute('error'),
};
